export function AktenSidebarAssistantsPhone() {
    return null
}